export enum BusinessChoiceType {
  B2B = 'b2b',
  B2C = 'b2c',
}

export enum FlowChoiceType {
  SIMPLE = 'simple',
  COMPLEX = 'complex',
}

export enum SupportedCountries {
  LUXEMBOURG = 'fr-lu',
  FRANCE = 'fr-fr',
  // BELGIUM = 'bebe'
}

export type ClientDetails = {
  lastName: string;
  firstName: string;
  email: string;
  mobileNumber: string;
  language: string;
  country: string;
  street: string;
  postalCode: string;
  city: string;
  department: string;
  requestDescription: string;
  workingTypes: string[];
  origin: string;
  utm: string;

  // B2B only
  isCompany: boolean;
  companyName?: string; // Note: mandatory if isCompany is true!
  vatNumber?: string;
};
